import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function MobileConnection(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      sx,
      viewBox,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "MobileConnection",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m9.74999 14.25-4.01925-3.7567c-.25699-.2324-.42293-.54866-.46814-.89217-.04521-.34352.03327-.69191.22139-.98287l.7215-1.125c.13846-.20252.31887-.37287.52898-.4995.21011-.12663.44501-.20656.68875-.23438.24374-.02782.49061-.00286.72385.07316.23325.07603.4474.20136.62792.36747L29.25 22.5v-5.25c0-.7956.3161-1.5587.8787-2.1213.5626-.5626 1.3256-.8787 2.1213-.8787h.1185c.3765.0001.7392.1417 1.0161.3968.2769.2551.4478.605.4786.9802l1.2803 15.5573c.0689.6892.3741 1.3334.864 1.8232L39 36l-9 9-2.4323-2.4322c-.8438-.8437-1.9882-1.3177-3.1815-1.3178h-1.0297c-1.9891 0-3.8968-.7902-5.3033-2.1967L9.74999 28.5V14.25Z",
            fill: theme.vars.palette.secondary.dark
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "m42.75 38.25-4.5-4.5-10.875 10.875L28.5 45.75h14.25v-7.5Z", fill: theme.vars.palette.primary.light }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M26.25 2.25h-13.5c-1.6569 0-3 1.34315-3 3v28.5c0 1.6569 1.3431 3 3 3h13.5c1.6569 0 3-1.3431 3-3V5.25c0-1.65685-1.3431-3-3-3Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.25 5.25h16.5v27h-16.5v-27Zm7.5 30h1.5c.1989 0 .3897-.079.5303-.2197.1407-.1406.2197-.3314.2197-.5303 0-.1989-.079-.3897-.2197-.5303-.1406-.1407-.3314-.2197-.5303-.2197h-1.5c-.1989 0-.3897.079-.5303.2197-.1407.1406-.2197.3314-.2197.5303 0 .1989.079.3897.2197.5303.1406.1407.3314.2197.5303.2197Zm3.375-31.125c.2071 0 .375-.16789.375-.375s-.1679-.375-.375-.375-.375.16789-.375.375.1679.375.375.375Zm-5.25 0h3.75c.2071 0 .375-.16789.375-.375s-.1679-.375-.375-.375h-3.75c-.2071 0-.375.16789-.375.375s.1679.375.375.375Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M14.9997 19.5c.1118.0003.2222-.0245.3231-.0727.1009-.0481.1896-.1184.2596-.2056.4534-.612 1.044-1.1093 1.7242-1.452.6803-.3426 1.4314-.5211 2.1931-.5211.7617 0 1.5128.1785 2.1931.5211.6802.3427 1.2707.84 1.7241 1.452.061.0794.1373.1457.2243.1951.0871.0494.1831.0809.2825.0927.0994.0117.2001.0034.2962-.0244.0962-.0278.1858-.0746.2635-.1375.0778-.063.1422-.1409.1894-.2291.0472-.0883.0763-.1851.0855-.2847.0093-.0997-.0015-.2002-.0317-.2956-.0303-.0954-.0793-.1838-.1442-.2599-.6044-.7745-1.3747-1.4037-2.2543-1.8412-.8796-.4375-1.8461-.6723-2.8284-.6871-.9823.0148-1.9488.2496-2.8284.6871-.8796.4375-1.6499 1.0667-2.2544 1.8412-.089.11-.1451.2431-.1617.3837-.0166.1406.0069.2831.0679.4109.0609.1278.1568.2357.2766.3113.1197.0756.2584.1157.4.1158Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.875 21.75c.1189.0001.2362-.028.342-.0822.1059-.0541.1974-.1326.267-.2291.2159-.3454.5119-.6337.8628-.8407.3509-.2069.7464-.3262 1.1532-.348.4069.0216.8026.141 1.1537.3479.351.2069.6471.4953.8631.8408.1169.1597.2923.2667.4878.2976.1956.0309.3954-.0167.5559-.1325.1606-.1158.2688-.2904.3012-.4857.0323-.1953-.0138-.3955-.1284-.5568-.3554-.538-.8343-.9831-1.3968-1.2982-.5625-.3151-1.1922-.491-1.8365-.5131-.6443.0221-1.274.198-1.8365.5131s-1.0414.7602-1.3967 1.2982c-.0808.112-.1291.2441-.1396.3818-.0105.1377.0173.2756.0802.3985.0629.123.1585.2261.2763.2982.1178.0721.2532.1102.3913.1102Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.5 23.25c.1989.001.3901-.0771.5314-.217.1414-.14.2214-.3303.2223-.5293.001-.1989-.077-.39-.217-.5314-.1399-.1413-.3303-.2213-.5292-.2223H19.5c-.1989 0-.3897.079-.5303.2197-.1407.1406-.2197.3314-.2197.5303 0 .1989.079.3897.2197.5303.1406.1407.3314.2197.5303.2197Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.75 26.4383v1.2165c.013.262-.0427.5228-.1616.7567-.1188.2339-.2967.4326-.516.5766-.2193.144-.4724.2282-.7343.2443-.2618.016-.5233-.0366-.7586-.1526l-2.99999-1.593c-.25418-.1404-.46555-.347-.61162-.5979-.14607-.251-.22137-.5368-.21788-.8271v-1.2165c-.01297-.2621.04274-.5229.16159-.7568.11886-.2339.29675-.4326.51605-.5766.2193-.144.4724-.2282.73425-.2443.26184-.016.52335.0366.75861.1527l2.99999 1.593c.2542.1403.4656.3469.6116.5979.1461.2509.2214.5367.2179.8271Z",
            fill: theme.vars.palette.secondary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.564 28.3252c.1226-.0077.2373-.0636.3189-.1555.0816-.0918.1236-.2122.1168-.335v-.7064c.0017-.0894-.0206-.1776-.0645-.2554-.0439-.0778-.1079-.1424-.1852-.1871l-1.056-.3878c-.0569-.0309-.1205-.0474-.1853-.048-.1226.0077-.2373.0636-.3189.1555s-.1236.2123-.1168.335v.7095c-.0016.0894.0208.1776.0648.2555.0441.0778.1082.1424.1857.187l1.0552.3878c.0569.0308.1205.0473.1853.0479v-.003Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.75 21.9383v1.2165c.013.262-.0427.5228-.1616.7567-.1188.2339-.2967.4326-.516.5766-.2193.144-.4724.2282-.7343.2443-.2618.016-.5233-.0366-.7586-.1526l-2.99999-1.593c-.25418-.1404-.46555-.347-.61162-.5979-.14607-.251-.22137-.5368-.21788-.8271v-1.2165c-.01297-.2621.04274-.5229.16159-.7568.11886-.2339.29675-.4326.51605-.5766.2193-.144.4724-.2282.73425-.2443.26184-.016.52335.0366.75861.1527l2.99999 1.593c.2542.1403.4656.3469.6116.5979.1461.2509.2214.5367.2179.8271Z",
            fill: theme.vars.palette.secondary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.564 23.8253c.1226-.0078.2373-.0637.3189-.1555.0816-.0919.1236-.2123.1168-.335v-.7066c.0017-.0893-.0206-.1775-.0645-.2553-.0439-.0778-.1079-.1424-.1852-.1872l-1.056-.3877c-.0569-.0309-.1205-.0474-.1853-.048-.1226.0077-.2373.0636-.3189.1555s-.1236.2123-.1168.335v.7095c-.0016.0894.0208.1776.0648.2555.0441.0778.1082.1424.1857.187l1.0552.3878c.0569.0308.1205.0473.1853.0479v-.0029Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.75 17.4383v1.2165c.013.262-.0427.5228-.1616.7567-.1188.2339-.2967.4326-.516.5766-.2193.144-.4724.2282-.7343.2443-.2618.016-.5233-.0366-.7586-.1526l-2.99999-1.593c-.25418-.1404-.46555-.347-.61162-.5979-.14607-.251-.22137-.5368-.21788-.8271v-1.2165c-.01297-.2621.04274-.5229.16159-.7568.11886-.2339.29675-.4326.51605-.5766.2193-.144.4724-.2282.73425-.2443.26184-.016.52335.0366.75861.1527l2.99999 1.593c.2542.1403.4656.3469.6116.5979.1461.2509.2214.5367.2179.8271Z",
            fill: theme.vars.palette.secondary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.564 19.3253c.1226-.0078.2373-.0637.3189-.1555.0816-.0919.1236-.2123.1168-.335v-.7066c.0017-.0893-.0206-.1775-.0645-.2553-.0439-.0778-.1079-.1424-.1852-.1872l-1.056-.3877c-.0569-.0309-.1205-.0474-.1853-.048-.1226.0077-.2373.0636-.3189.1555s-.1236.2123-.1168.335v.7095c-.0016.0894.0208.1776.0648.2555.0441.0778.1082.1424.1857.187l1.0552.3878c.0569.0308.1205.0473.1853.0479v-.0029Z",
            fill: theme.vars.palette.secondary.main
          }
        )
      ]
    }
  );
}
MobileConnection.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "MobileConnection"
};
validateTidalLicense();
export {
  MobileConnection
};
//# sourceMappingURL=MobileConnection.js.map
